// extracted by mini-css-extract-plugin
module.exports = {"center":"SingleBlog_center__9a5Xv","avatar":"SingleBlog_avatar__2-fbx","content":"SingleBlog_content__1RSS4"};